import "./ToolbarModal.scss";
import classNames from "classnames";
import {useEffect, useRef} from "react";

const ToolbarModal = ({className, children, onClose}) => {
    const modalRef = useRef(null);

    const handleClickOutside = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            onClose(false);
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {document.removeEventListener('mousedown', handleClickOutside);};
    }, []);

    return <div ref={modalRef} className={classNames("toolbar-modal", className)}>
        {children}
    </div>
}

export default ToolbarModal